"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formik_1 = require("formik");
var react_1 = __importStar(require("react"));
var Input_1 = __importDefault(require("../inputs/Input"));
var EmailField = function (_a) {
    var name = _a.name, size = _a.size, readOnly = _a.readOnly, toolTip = _a.toolTip, maxLength = _a.maxLength;
    var _b = formik_1.useField(name), field = _b[0], meta = _b[1], helpers = _b[2];
    var _c = react_1.useState(), errorMessage = _c[0], setErrorMessage = _c[1];
    var handleOnChange = function (input) {
        var validEmail = new RegExp('^([a-zA-Z0-9]([.!#$%&*+\\-\\/=?^_{|}]?[a-zA-Z0-9])*)(?<!.{65})@((?![a-zA-Z0-9-]{64})([a-zA-Z0-9]+(-?[a-zA-Z0-9])*)\\.)+(?!.{64})[a-zA-Z]+$');
        helpers.setValue(input.target.value);
        setErrorMessage(undefined);
        if (input.target.value === '') {
            return;
        }
        if (validEmail.test(input.target.value)) {
            return;
        }
        setErrorMessage('E-mail není validní.');
        return;
    };
    return (react_1.default.createElement(Input_1.default, __assign({}, field, { value: field.value || '', name: name, hasError: !!meta.error, size: size, readOnly: readOnly, toolTip: toolTip, onChange: handleOnChange, errorMessage: errorMessage, maxLength: maxLength })));
};
EmailField.defaultProps = {
    size: undefined,
    readOnly: false,
    toolTip: undefined,
    maxLength: undefined,
};
exports.default = EmailField;
